import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { UmsService } from '../ums.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { element } from 'protractor';

@Component({
  selector: 'app-permission',
  templateUrl: './permission.component.html',
  styleUrls: ['./permission.component.scss']
})
export class PermissionComponent implements OnInit {
  permissionForm: FormGroup;
  allPages: any = [];
  tab = true;
  page = true;
  userPermission: any;
  adminenable: boolean = false;
  superenable: boolean = false;
  processenable: boolean = false;
  inputenable: boolean = false;
  errormessage: string;
  searchText: any;
  userlist: any;
  totalLength: any;
  id: any;
  rolesList: any;
  BranchList: any;
  userId: string;
  userdetails: any;
  collegedataList: any;
  filteredCollegeList: any;
  submitpayload: any;
  perList = [];
  dialogRef: MatDialogRef<any>;
  stocktabenable: boolean;
  tabenable: boolean;
  view: boolean;
  roleList: any;
  filteredListOfRole: any;
  feesenable: boolean;
  constructor(
    private fb: FormBuilder,
    private _snackBar: MatSnackBar,
    public umsService: UmsService,
    public router: Router,
    public dialog: MatDialog,
    public datepipe: DatePipe,
    private spinner: NgxSpinnerService,
    private modalPopupService: ModalpopService,
  ) { }
  status: any;
  submitButton = true;
  updateButton = false;
  deleteButton = false;
  cancelButton = false;
  loggedId: any;
  myimage;
  date: any;
  size: number = 5;
  page2: number = 1;
  isPassword = true;
  //permission code
  @Output() prev = new EventEmitter<void>();
  user_role: any;
  customerType: any;
  PView = false;
  listofCustomer: any;
  listofuser: any;
  dashboard_view: any;
  Tab1 = false;
  Tab2 = false;
  Tab3 = false;
  Tab4 = false;
  CreateTab1 = false;
  CreateTab2 = false;
  CreateTab3 = false;
  CreateTab4 = false;
  UpdateTab1 = false;
  UpdateTab2 = false;
  UpdateTab3 = false;
  UpdateTab4 = false;
  DeleteTab1 = false;
  DeleteTab2 = false;
  DeleteTab3 = false;
  DeleteTab4 = false;
  CreateTab = true;
  permission: any = [];
  user: any = [];
  selectedItemsList: any;
  listofcustuser: any;
  userSelectList: any = [];
  tempArray: any = [];
  customerRefId: any;
  userData: any;
  listOfRole: any;
  checkCust: Boolean = true;
  checkUser: Boolean = true;
  disableField: Boolean = false;
  mastertabenable: boolean = false;
  userType: any;
  custRefId: any;
  permissionList = [];
  permissionCreate = true;
  permissionUpdate = true;
  clinicRef: string;
  showclg = false;
  userid;
  userNm;
  ngOnInit(): void {
    // this.updateButton
    this.userid = sessionStorage.getItem('loginId');
    this.userNm = sessionStorage.getItem('loginName');
    this.permissionForm = this.fb.group({
      "UserId": new FormControl(this.userid),
      "Usernm": new FormControl(this.userNm),
      "UserRole": new FormControl('', Validators.required),
      "CgUi": new FormControl('', Validators.required),
      "CgId": new FormControl(''),
      "PSelect": new FormControl(false),
      //permission code
      "PageName": new FormControl(''),
      "PView": new FormControl(''),
      "PCreate": new FormControl(''),
      "PUpdate": new FormControl(''),
      "PDelete": new FormControl(''),
      "IsTab": new FormControl(''),
      "userPermission": new FormControl(),
      "menu": new FormControl(),
      userPermissionArr: this.fb.array([]),
    });
    let arr = [];
    this.allPages = [];
    this.router.config.forEach((e, i) => {
      if (e.data !== undefined) {
        arr.push(e.data.name);
        //  this.allPages.push({PageName:e.data.name,selectAll:false,view:false,create:false,PUpdate:false,delete:false,IsTab:e.data.IsTab});
        if (this.allPages.indexOf(e.data.name) === -1) {
          this.allPages.push({ PageName: e.data.name, PSelect: false, PView: false, PCreate: false, PUpdate: false, PDelete: false, IsTab: e.data.IsTab,MenuName: e.data.MenuName });
       }
      }
      
    })
  
    this.prepopulation();
    // if(this.userid){
    //   this.prepopulation(this.userid);
    //   }else{
    //     this.disableField = true;
    //   }
    this.fetchRolelist();
  }


  getCollegeData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCollege(payload).subscribe((res) => {
      this.collegedataList = res.data;
      this.filteredCollegeList = this.collegedataList.slice();
      this.spinner.hide();
    }, (ERROR: HttpErrorResponse) => {
      this.collegedataList = [];
      this.spinner.hide();
    })
  }

  selsectClgUni(event: any) {
    const selectedValue = event.value;
    if (selectedValue == 'C') {
      this.showclg = true;
      this.getCollegeData();
    }
    else {
      this.showclg = false;
    let uni =  this.umsService.secretdata['ClubPartTrans'];
    this.permissionForm.controls['CgId'].setValue(uni);
    }
  }

  submitPermi() {
    // this.spinner.show();
    let payload = {}
    payload = this.permissionForm.value;
    let finalpayload = {}
    finalpayload['userPermissionArr'] = this.allPages;
    this.allPages.forEach(element => {
      element['UserId'] = this.permissionForm.value.UserId;
      element['UserRole'] = this.permissionForm.value.UserRole;
      element['CgUi'] = this.permissionForm.value.CgUi;
      element['CgId'] = this.permissionForm.value.CgId;
      this.umsService.addPermission(element).subscribe(res => {
        if (res.status) {
          
        }
        else {
          ;
        }
      });
    });
    let data = {};
    data['message'] = "Submitted Successfully";
    data['title'] = 'Information';
    data['icon'] = 'fas fa-check';
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      this.prev.emit();
    });
  }

  submit() {

    if (this.permissionForm.invalid) {
      this.permissionForm.get('UserRole').markAsTouched();
      this.permissionForm.get('CgUi').markAsTouched();
      return;
    } else {
      this.submitPermi();
    }
  }

  update() {
    // this.spinner.show();
    let payload = {}
    payload = this.permissionForm.value;
    let finalpayload = {}
    finalpayload['userPermissionArr'] = this.allPages;
    this.allPages.forEach(element => {
      element['UserId'] = this.permissionForm.value.UserId;
      element['UserRole'] = this.permissionForm.value.UserRole;
      element['CgUi'] = this.permissionForm.value.CgUi;
      element['CgId'] = this.permissionForm.value.CgId;
      this.umsService.updatePermission(element).subscribe(res => {
        if (res.status) {
        }
        else {
          ;
        }
      });
    });
    let data = {};
    data['message'] = "Updated Successfully";
    data['title'] = 'Information';
    data['icon'] = 'fas fa-check';
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      this.ngOnInit();
      
    });
  }


  prepopulation() {
    this.submitButton = true;
    this.updateButton = false;
    this.spinner.show();
    let payload = {};
    payload['UserId'] = this.userid;
    
    this.umsService.getPermission(payload).subscribe(res => {
      this.spinner.hide();
      
      if (res.status) {
        let aaaryy = [];
        aaaryy = res.data;
         this.submitButton = false;
        this.updateButton = true;
        const ids = aaaryy.map(o => o.PermissionId);
        let data = res.data[0];
        this.allPages = aaaryy.filter(({ pageeeName }, index) => !ids.includes(pageeeName, index + 1))
        if (this.allPages.length !== 0) {
          for (let i = 0; i < this.allPages.length; i++) {
  
            if (this.allPages[i].PageName == "Admin") {
              if (this.allPages[i].PView == true) {
                this.adminenable = true;
              } else {
                this.adminenable = false;
              } 
            }
            if (this.allPages[i].PageName == "Master") {
              if (this.allPages[i].PView == true) {
                this.mastertabenable = true;
              } else {
                this.mastertabenable = false;
              }
            }
            if (this.allPages[i].PageName == "Supervisor") {
              if (this.allPages[i].PView == true) {
                this.superenable = true;
              } else {
                this.superenable = false;
              }
            }
            if (this.allPages[i].PageName == "Processing") {
              if (this.allPages[i].PView == true) {
                this.processenable = true;
              } else {
                this.processenable = false;
              }
            }
            if (this.allPages[i].PageName == "Input") {
              if (this.allPages[i].PView == true) {
                this.inputenable = true;
              } else {
                this.inputenable = false;
              }
            }
  
            if (this.allPages[i].PageName == "Fee") {
              if (this.allPages[i].PView == true) {
                this.feesenable = true;
              } else {
                this.feesenable = false;
              } 
            }
          }
        }
        if (this.allPages.length == 0) {
          this.allPages = this.tempArray;
          for (let i = 0; i < this.tempArray.length; i++) {
  
            if (this.tempArray[i].PageName == "Admin") {
              if (this.tempArray[i].PView == true) {
                this.adminenable = true;
              } else {
                this.adminenable = false;
              }
            }
            if (this.tempArray[i].PageName == "Master") {
              if (this.tempArray[i].PView == true) {
                this.mastertabenable = true;
              } else {
                this.mastertabenable = false;
              }
            }
  
            if (this.tempArray[i].PageName == "Supervisor") {
              if (this.tempArray[i].PView == true) {
                this.superenable = true;
              } else {
                this.superenable = false;
              }
            }
            if (this.tempArray[i].PageName == "Processing") {
              if (this.tempArray[i].PView == true) {
                this.processenable = true;
              } else {
                this.processenable = false;
              }
            }
            if (this.tempArray[i].PageName == "Input") {
              if (this.tempArray[i].PView == true) {
                this.inputenable = true;
              } else {
                this.inputenable = false;
              }
            }
            if (this.allPages[i].PageName == "Fee") {
              if (this.allPages[i].PView == true) {
                this.feesenable = true;
              } else {
                this.feesenable = false;
              } 
            }
          }
        }
        //   this.submitButton = false;
        // this.updateButton = true;
        if (data.CgUi == 'C') {
          this.showclg = true;
          this.getCollegeData();
        }
        this.permissionForm = this.fb.group({
          "UserId": new FormControl(data.UserId),
          "Usernm": new FormControl(this.userNm),
          "UserRole": new FormControl(data.UserRole),
          "CgUi": new FormControl(data.CgUi),
          "CgId": new FormControl(data.CgId),
          "PSelect": new FormControl(data.PSelect ? data.PSelect : false),

        });
      }
      else{
        this.spinner.hide();
         this.submitButton = true;
        this.updateButton = false;
        let aaaryy = [];
        aaaryy = this.allPages;
        const ids = aaaryy.map(o => o.MenuName);
        this.allPages = aaaryy.filter(({ pageeeName }, index) => !ids.includes(pageeeName, index + 1))
        if (this.allPages.length !== 0) {
          for (let i = 0; i < this.allPages.length; i++) {
            if (this.allPages[i].PageName == "Admin") {
              if (this.allPages[i].PView == true) {
                this.adminenable = true;
              } else {
                this.adminenable = false;
              } 
            }
            if (this.allPages[i].PageName == "Master") {
              if (this.allPages[i].PView == true) {
                this.mastertabenable = true;
              } else {
                this.mastertabenable = false;
              }
            }
            if (this.allPages[i].PageName == "Supervisor") {
              if (this.allPages[i].PView == true) {
                this.superenable = true;
              } else {
                this.superenable = false;
              }
            }
            if (this.allPages[i].PageName == "Processing") {
              if (this.allPages[i].PView == true) {
                this.processenable = true;
              } else {
                this.processenable = false;
              }
            }
            if (this.allPages[i].PageName == "Input") {
              if (this.allPages[i].PView == true) {
                this.inputenable = true;
              } else {
                this.inputenable = false;
              }
            }
  
            if (this.allPages[i].PageName == "Fee") {
              if (this.allPages[i].PView == true) {
                this.feesenable = true;
              } else {
                this.feesenable = false;
              } 
            }
          }
        }
        if (this.allPages.length == 0) {
          this.allPages = this.tempArray;
          for (let i = 0; i < this.tempArray.length; i++) {
  
            if (this.tempArray[i].PageName == "Admin") {
              if (this.tempArray[i].PView == true) {
                this.adminenable = true;
              } else {
                this.adminenable = false;
              }
            }
            if (this.tempArray[i].PageName == "Master") {
              if (this.tempArray[i].PView == true) {
                this.mastertabenable = true;
              } else {
                this.mastertabenable = false;
              }
            }
  
            if (this.tempArray[i].PageName == "Supervisor") {
              if (this.tempArray[i].PView == true) {
                this.superenable = true;
              } else {
                this.superenable = false;
              }
            }
            if (this.tempArray[i].PageName == "Processing") {
              if (this.tempArray[i].PView == true) {
                this.processenable = true;
              } else {
                this.processenable = false;
              }
            }
            if (this.tempArray[i].PageName == "Input") {
              if (this.tempArray[i].PView == true) {
                this.inputenable = true;
              } else {
                this.inputenable = false;
              }
            }
            if (this.allPages[i].PageName == "Fee") {
              if (this.allPages[i].PView == true) {
                this.feesenable = true;
              } else {
                this.feesenable = false;
              } 
            }
          }
        }
        
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      // let data = {};
      // data['message'] = ERROR.error.message;
      // data['title'] = 'Information';
      // data['icon'] = 'fas fa-close';
      // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
      //   AlertBoxComponent,
      //   data
      // );
    });
  }


  // prepopulation() {
  //     let payload = {};
  //   payload['UserId'] = this.userid;
  //   this.umsService.getPermission(payload).subscribe(res => {
  //     //permission coe
  //     this.userData = res.data;
  //     this.allPages = res.data;
  //     let aaaryy = [];
  //     aaaryy = res.data;
  //    const ids = aaaryy.map(o => o.MenuName);
  //     this.allPages = aaaryy.filter(({ pageeeName }, index) => !ids.includes(pageeeName, index ))

  //         if (this.allPages.length !== 0) {
  //       for (let i = 0; i < this.allPages.length; i++) {

  //         if (this.allPages[i].PageName == "Admin") {
  //           if (this.allPages[i].PView == true) {
  //             this.adminenable = true;
  //           } else {
  //             this.adminenable = false;
  //           } 
  //         }
  //         if (this.allPages[i].PageName == "Master") {
  //           if (this.allPages[i].PView == true) {
  //             this.mastertabenable = true;
  //           } else {
  //             this.mastertabenable = false;
  //           }
  //         }
  //         if (this.allPages[i].PageName == "Supervisor") {
  //           if (this.allPages[i].PView == true) {
  //             this.superenable = true;
  //           } else {
  //             this.superenable = false;
  //           }
  //         }
  //         if (this.allPages[i].PageName == "Processing") {
  //           if (this.allPages[i].PView == true) {
  //             this.processenable = true;
  //           } else {
  //             this.processenable = false;
  //           }
  //         }
  //         if (this.allPages[i].PageName == "Input") {
  //           if (this.allPages[i].PView == true) {
  //             this.inputenable = true;
  //           } else {
  //             this.inputenable = false;
  //           }
  //         }

  //         if (this.allPages[i].PageName == "Fee") {
  //           if (this.allPages[i].PView == true) {
  //             this.feesenable = true;
  //           } else {
  //             this.feesenable = false;
  //           } 
  //         }
  //       }
  //     }
  //     if (this.allPages.length == 0) {
  //       this.allPages = this.tempArray;
  //       for (let i = 0; i < this.tempArray.length; i++) {

  //         if (this.tempArray[i].PageName == "Admin") {
  //           if (this.tempArray[i].PView == true) {
  //             this.adminenable = true;
  //           } else {
  //             this.adminenable = false;
  //           }
  //         }
  //         if (this.tempArray[i].PageName == "Master") {
  //           if (this.tempArray[i].PView == true) {
  //             this.mastertabenable = true;
  //           } else {
  //             this.mastertabenable = false;
  //           }
  //         }

  //         if (this.tempArray[i].PageName == "Supervisor") {
  //           if (this.tempArray[i].PView == true) {
  //             this.superenable = true;
  //           } else {
  //             this.superenable = false;
  //           }
  //         }
  //         if (this.tempArray[i].PageName == "Processing") {
  //           if (this.tempArray[i].PView == true) {
  //             this.processenable = true;
  //           } else {
  //             this.processenable = false;
  //           }
  //         }
  //         if (this.tempArray[i].PageName == "Input") {
  //           if (this.tempArray[i].PView == true) {
  //             this.inputenable = true;
  //           } else {
  //             this.inputenable = false;
  //           }
  //         }
  //         if (this.allPages[i].PageName == "Fee") {
  //           if (this.allPages[i].PView == true) {
  //             this.feesenable = true;
  //           } else {
  //             this.feesenable = false;
  //           } 
  //         }
  //       }
  //     }
  //     //end permission code
  //    let data = res.data[0];
  //    this.submitButton = false;
  //    this.updateButton = true;
  //     if(res.status){
  //            this.permissionForm = this.fb.group({
  //         "UserId": new FormControl(data.UserId),
  //         "Usernm": new FormControl(this.userNm),
  //         "UserRole": new FormControl(data.UserRole),
  //         "CgUi": new FormControl(data.CgUi),
  //         "CgId": new FormControl(data.CgId),
  //         "PSelect": new FormControl(data.PSelect ? data.PSelect : false),

  //       });
        
  //     }
  //   });
  // }
  
  fetchRolelist() {
    const payload = {};
    payload['CdType'] = 'Role';
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.roleList = res.data;
        this.filteredListOfRole = this.roleList.slice();
      } else {
      }
    });
  }
  
  
  ///user permissions
  onTabChange(e) {

    if (e.target.checked) {

      this.tab = true;
    }
    else {

      this.tab = false;
    }
  }
  onPageChange2(e) {

    if (e.target.checked) {

      this.page = true;
    }
    else {

      this.page = false;
    }
  }

  onSelectAllChange(e) {
    if (e.target.checked == true) {
      //this.permission.push(e.target.value);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PSelect = true;
          this.allPages[i].PView = true;
          this.allPages[i].PCreate = true;
          this.allPages[i].PUpdate = true;
          this.allPages[i].PDelete = true;
        }
        if (e.target.value == "Stock") {
          this.stocktabenable = true;
        }
        if (e.target.value == "Settings") {
          this.tabenable = true;
        }
      }

    }

    if (e.target.checked == false) {
      //this.permission.splice(this.permission.indexOf(e.target.value),1);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PSelect = false;
          this.allPages[i].PView = false;
          this.allPages[i].PCreate = false;
          this.allPages[i].PUpdate = false;
          this.allPages[i].PDelete = false;
        }
        if (e.target.value == "Stock") {
          this.stocktabenable = false;
        }
        if (e.target.value == "Settings") {
          this.tabenable = false;
        }
      }

    }
  }

  onSelectAllPagesChange(e) {
    if (e.checked == true) {
      //this.permission.push(e.target.value);
      for (let i = 0; i < this.allPages.length; i++) {

        this.allPages[i].PSelect = true;
        this.allPages[i].PView = true;
        this.allPages[i].PCreate = true;
        this.allPages[i].PUpdate = true;
        this.allPages[i].PDelete = true;
        this.stocktabenable = true;
        this.tabenable = true;
      }

    }

    if (e.checked == false) {
      //this.permission.splice(this.permission.indexOf(e.target.value),1);
      for (let i = 0; i < this.allPages.length; i++) {

        this.allPages[i].PSelect = false;
        this.allPages[i].PView = false;
        this.allPages[i].PCreate = false;
        this.allPages[i].PUpdate = false;
        this.allPages[i].PDelete = false;
        this.stocktabenable = false;
        this.tabenable = false;

      }

    }
  }

  onViewChange(e) {
    if (e.target.checked == true) {
      this.permission.push(e.target.value);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PView = true;
          if (this.allPages[i].PView == true && this.allPages[i].PCreate == true && this.allPages[i].PUpdate == true && this.allPages[i].PDelete == true) {
            this.allPages[i].PSelect = true;
          }
        }

        if (e.target.value == "Stock") {
          this.stocktabenable = true;
        }
        if (e.target.value == "Settings") {
          this.tabenable = true;
        }
      }

    }

    if (e.target.checked == false) {
      this.permission.splice(this.permission.indexOf(e.target.value), 1);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PView = false;
          this.allPages[i].PCreate = false;
          this.allPages[i].PUpdate = false;
          this.allPages[i].PDelete = false;
          this.allPages[i].PSelect = false;
        }
        if (e.target.value == "Stock") {
          this.stocktabenable = false;
        }
        if (e.target.value == "Settings") {
          this.tabenable = false;
        }
      }

    }

    if (e.target.checked && e.target.value == 'setting_view') {
      this.dashboard_view = 'setting_view';
      this.Tab1 = true;
      this.Tab2 = true;
      this.Tab3 = true;
      this.Tab4 = true;
    }
    else {
      this.Tab1 = false;
      this.Tab2 = false;
      this.Tab3 = false;
      this.Tab4 = false;
    }
    if (e.target.checked && e.target.value == 'dashboard_view') {
      this.view = true;
    }
    else {
      this.view = false;
    }

  }
  onCreateChange(e) {
    if (e.target.checked == true) {
      this.permission.push(e.target.value);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].create = true;
          if (this.allPages[i].PSelect == false && this.allPages[i].view == true && this.allPages[i].create == true && this.allPages[i].update == true && this.allPages[i].delete == true) {
            this.allPages[i].PSelect = true;
          }
        }
      }
    }

    if (e.target.checked == false) {
      this.permission.splice(this.permission.indexOf(e.target.value), 1);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].create = false;
          if (this.allPages[i].PSelect == true && this.allPages[i].create == false && this.allPages[i].view == true && this.allPages[i].update == true && this.allPages[i].delete == true) {
            this.allPages[i].PSelect = false;
          }
        }
      }
    }


    if (e.target.checked && e.target.value == 'setting_create') {
      this.CreateTab1 = true;
      this.CreateTab2 = true;
      this.CreateTab3 = true;
      this.CreateTab4 = true;
    }
    else {
      this.CreateTab1 = false;
      this.CreateTab2 = false;
      this.CreateTab3 = false;
      this.CreateTab4 = false;
    }

  }

  onUpdateChange(e) {
    if (e.target.checked == true) {
      this.permission.push(e.target.value);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PUpdate = true;

          if (this.allPages[i].PSelect == false && this.allPages[i].PView == true && this.allPages[i].PCreate == true && this.allPages[i].PUpdate == true && this.allPages[i].PDelete == true) {
            this.allPages[i].PSelect = true;
          }
        }
      }

    }

    if (e.target.checked == false) {
      this.permission.splice(this.permission.indexOf(e.target.value), 1);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PUpdate = false;

          if (this.allPages[i].PSelect == true && this.allPages[i].PCreate == true && this.allPages[i].PView == true && this.allPages[i].PUpdate == false && this.allPages[i].PDelete == true) {
            this.allPages[i].PSelect = false;
          }
        }
      }
    }
  }

  onDeleteChange(e) {
    if (e.target.checked == true) {
      this.permission.push(e.target.value);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PDelete = true;

          if (this.allPages[i].PSelect == false && this.allPages[i].PView == true && this.allPages[i].PCreate == true && this.allPages[i].PUpdate == true && this.allPages[i].PDelete == true) {
            this.allPages[i].PSelect = true;
          }
        }
      }
    }

    if (e.target.checked == false) {
      this.permission.splice(this.permission.indexOf(e.target.value), 1);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PDelete = false;
          if (this.allPages[i].PSelect == true && this.allPages[i].PCreate == true && this.allPages[i].PView == true && this.allPages[i].PUpdate == true && this.allPages[i].PDelete == false) {
            this.allPages[i].PSelect = false;
          }
        }
      }
    }
  }

  onCheckboxViewChange(e) {
    if (e.target.checked == true) {
      this.permission.push(e.target.value);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PView = true;
          if (this.allPages[i].PView == true && this.allPages[i].PCreate == true && this.allPages[i].PUpdate == true && this.allPages[i].PDelete == true) {
            this.allPages[i].PSelect = true;
          }
        }
      }
    }

    if (e.target.checked == false) {
      this.permission.splice(this.permission.indexOf(e.target.value), 1);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PView = false;
          this.allPages[i].PCreate = false;
          this.allPages[i].PUpdate = false;
          this.allPages[i].PDelete = false;
          this.allPages[i].PSelect = false;
        }
      }
    }
  }

  onCheckboxCreateChange(e) {
    if (e.target.checked == true) {
      this.permission.push(e.target.value);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PCreate = true;
          if (this.allPages[i].PSelect == false && this.allPages[i].PView == true && this.allPages[i].PCreate == true && this.allPages[i].PUpdate == true && this.allPages[i].PDelete == true) {
            this.allPages[i].PSelect = true;
          }
        }
      }
    }
    if (e.target.checked == false) {
      this.permission.splice(this.permission.indexOf(e.target.value), 1);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PCreate = false;
          if (this.allPages[i].PSelect == true && this.allPages[i].PCreate == false && this.allPages[i].PView == true && this.allPages[i].PUpdate == true && this.allPages[i].PDelete == true) {
            this.allPages[i].PSelect = false;
          }
        }
      }

    }
  }

  onCheckboxUpdateChange(e) {
    if (e.target.checked == true) {
      this.permission.push(e.target.value);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PUpdate = true;
          if (this.allPages[i].PSelect == false && this.allPages[i].PView == true && this.allPages[i].PCreate == true && this.allPages[i].PUpdate == true && this.allPages[i].PDelete == true) {
            this.allPages[i].PSelect = true;
          }
        }
      }

    }

    if (e.target.checked == false) {
      this.permission.splice(this.permission.indexOf(e.target.value), 1);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PUpdate = false;

          if (this.allPages[i].PSelect == true && this.allPages[i].PCreate == true && this.allPages[i].PView == true && this.allPages[i].PUpdate == false && this.allPages[i].PDelete == true) {
            this.allPages[i].PSelect = false;
          }
        }
      }
    }
  }

  onCheckboxDeleteChange(e) {
    if (e.target.checked == true) {
      this.permission.push(e.target.value);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PDelete = true;
          if (this.allPages[i].PSelect == false && this.allPages[i].PView == true && this.allPages[i].PCreate == true && this.allPages[i].PUpdate == true && this.allPages[i].PDelete == true) {
            this.allPages[i].PSelect = true;
          }
        }
      }
    }

    if (e.target.checked == false) {
      this.permission.splice(this.permission.indexOf(e.target.value), 1);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PDelete = false;
          if (this.allPages[i].PSelect == true && this.allPages[i].PCreate == true && this.allPages[i].PView == true && this.allPages[i].PUpdate == true && this.allPages[i].PDelete == false) {
            this.allPages[i].PSelect = false;
          }
        }
      }
    }
  }
}
